import { DisplayBenefitType } from '@witkac/kartamiejska-shared';

export default {
  title: 'benefit',
  type: 'object',
  properties: {
    name: {
      title: 'Nazwa usługi',
      type: 'string',
      fieldRequired: true,
      maxLength: 500
    },
    description: {
      title: 'Opis usługi',
      type: 'string',
      fieldRequired: false
    },
    type: {
      title: 'Rodzaj rabatu',
      type: 'string',
      fieldRequired: true
    },
    value: {
      title: 'Wysokość rabatu',
      type: 'number',
      fieldRequired: true,
      validFunc: `this.type === '${DisplayBenefitType.PERCENT_DISCOUNT}' ? $value <= 100 : true`,
      validationMessages: {
        validFunc: 'Maksymalna wartość rabatu to 100%'
      },
      minimum: 0
    },
    groupIds: {
      title: 'Grupy',
      type: 'array',
      items: {
        type: 'number'
      }
    },
    categoryIds: {
      title: 'Grupy',
      type: 'array',
      items: {
        type: 'number'
      },
      fieldRequired: false
    },
    placeId: {
      title: 'Obiekt',
      type: 'number',
      fieldRequired: false
    },
    start: {
      title: 'Początek ważności usługi',
      type: 'string',
      format: 'date'
    },
    end: {
      title: 'Koniec ważności usługi',
      type: 'string',
      format: 'date',
      minimum: 'this.start'
    },
    max: {
      type: 'number',
      title: 'Maksymalna liczba użyć'
    },
    maxPerUser: {
      type: 'number',
      title: 'Maksymalna liczba użyć jednego użytkownika',
      validFunc: '$value && this.max ? $value <= this.max : true',
      validationMessages: {
        validFunc: 'Maksymalna liczba użyć jednego użytkownika nie może być większa niż maksymalna liczba użyć'
      }
    },
    images: {
      title: 'Pozostałe obrazki',
      type: 'string',
      default: ''
    },
    mainImage: {
      title: 'Obrazek tła',
      type: 'number'
    },
    descriptionShort: {
      type: 'string',
      maxLength: 500,
      fieldRequired: false
    },
    defaultPrice: {
      type: 'number',
      title: 'Domyślna cena'
    },
    defaultAmount: {
      type: 'number',
      title: 'Domyślna liczba użyć/minut'
    }
  }
};
